import { useCallback } from "react";
import { useCanvasFloatingChat } from "../context/CanvasFloatingChatContext";

/**
 * The New Chat circle is a toggle (ROUND2 §1): up, the click collapses the
 * window (the session stays on the stack); down, it expands. The page hands
 * `chatOpen` to the bar so the circle wears the pressed register.
 */
export function useNewChatToggle() {
  const { open, expand, collapse } = useCanvasFloatingChat();
  const toggle = useCallback(() => {
    if (open) collapse();
    else expand();
  }, [open, expand, collapse]);
  return { chatOpen: open, toggle };
}
